export const MENU_ITEM_SELECTOR =
  '[role="option"], [role="menuitem"], input[type="checkbox"]:not(.select-all)';
export const SEARCH_INPUT_SELECTOR = '[data-test-spds-menu-search-input]';

export default {
  MENU_ITEM_SELECTOR,
  SEARCH_INPUT_SELECTOR,
};
